module.exports = __webpack_public_path__ + "static/img/1.9a42b99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/sp/1.png
// module id = W5bJ
// module chunks = 0